<template>
  <ul>
    <li v-for="(tag, index) in topTagList" :key="index">
      <span v-if="tagData(tag)" :class="['badge artwork', `${tag?.className}`]">
        {{ tagData(tag)?.text }}</span
      >
    </li>
  </ul>
</template>
<script setup>
  import { defineProps } from 'vue'
  defineProps({
    topTagList: {
      type: Array,
      default: () => [],
    },
  })

  const TAG_MAP = {
    won: {
      text: '개별구매',
    },
    event: {
      text: '이벤트',
    },
    free: {
      text: '무료',
    },
    discount: {
      text: '할인',
    },
    quickvod: {
      className: 'quick-vod',
      text: 'Quick VOD',
    },
    recommend: {
      text: '추천',
    },
    reserve: {
      className: 'tag-reserve',
      text: '예약구매',
    },
    new: {
      text: 'NEW',
    },
  }

  const tagData = (tag) => {
    return TAG_MAP[tag] || null
  }
</script>
